import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./CheckoutPage.css";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import NewAddress from "./NewAddress";
import EditAddress from "./EditAddress";

const CheckoutPage = () => {
  const guestId = localStorage.getItem("guestId");
  const userId = localStorage.getItem("userId");
  const location = useLocation();
  const { appliedCode } = location.state || {};
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("onlinePayment");
  const [coupon, setCoupon] = useState("");
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [allAddresses, setAllAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [personaldetails, setpersonaldetails] = useState({
    name: "",
    phoneNumber: "",
  });
  const [addressErrors, setAddressErrors] = useState({});
  const [address, setAddress] = useState({
    houseName: "",
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "India",
  });
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [houseName, setHouseName] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [country, setCountry] = useState("");

  const [termsChecked, setTermsChecked] = useState(false);

  useEffect(() => {
    fetchAddresses();
    fetchUserDetails();
    fetchCartItems();
  }, []);

  useEffect(() => {
    getCopounData();
  });
  const handleEditAddressClick = (address) => {
    setSelectedAddress(address);
  };
  const fetchUserDetails = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await axios.get(
        `${BASE_URL}/users/getUserNamePhone/${userId}`
      );
      const [name, phoneNumber] = response.data;
      setpersonaldetails({ name, phoneNumber });
    } catch (error) {
      console.error("Error Name and Phone Number", error);
    }
  };
  const fetchAddresses = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const response = await axios.get(
        `${BASE_URL}/users/getAllAddresses/${userId}`
      );
      if (response.data && response.data.length > 0) {
        setAllAddresses(response.data);
        setSelectedAddress(response.data[0]);
        updateAddressFields(response.data[0]);
      }
      console.log(response.data.length);
    } catch (error) {
      toast.warn("Please Add Address to Place Order");
    }
  };

  const updateAddressFields = (selectedAddress) => {
    setAddress({
      houseName: selectedAddress.houseName,
      street: selectedAddress.street,
      city: selectedAddress.city,
      state: selectedAddress.state,
      pinCode: selectedAddress.pinCode,
      country: "India",
    });
  };

  const fetchCartItems = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (userId || guestId) {
        const response = await axios.post(
          `${BASE_URL}/usercart/in-cart?userId=${userId || guestId}`
        );
        setCartItems(response.data);
        let subtotal = 0;
        response.data.forEach((item) => {
          subtotal += item.productRate * item.orderQuantity;
        });
        setSubtotal(subtotal);
        setTotal(subtotal);
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const handlePaymentMethodChange = (event) => {
    setSelectedPaymentMethod(event.target.value);
  };

  const handleSelectAddress = (selectedAddress) => {
    setSelectedAddress(selectedAddress);
    updateAddressFields(selectedAddress);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "name" || name === "phoneNumber") {
      setpersonaldetails((prevDetails) => ({
        ...prevDetails,
        [name]: value,
      }));
    } else {
      setAddress((prevAddress) => ({
        ...prevAddress,
        [name]: value,
      }));
    }
  };

  const placeOrder = async () => {
    try {
      if (allAddresses.length === 0) {
        const addressAdded = await handleAddAddress();
        if (!addressAdded) {
          return;
        }
      }

      if (!termsChecked) {
        toast.error(
          "Please agree to the terms & conditions before placing the order."
        );
        return;
      }

      const userId = localStorage.getItem("userId");
      const { addrId } = selectedAddress ? selectedAddress : 1;
      const paymentMethod = selectedPaymentMethod;
      let orderAmount = total;
      setTotal(orderAmount);
      setCouponApplied(true);
      let discountVal = parseFloat(discount).toFixed(1);
      let shipping = parseFloat(deliveryCharge).toFixed(1);
      const response = await axios.post(
        `${BASE_URL}/usercart/finalize?userId=${userId}&finalOrderAmount=${orderAmount}&addrId=${addrId}&paymentMethod=${paymentMethod}&discount=${discountVal}&shipping=${shipping}`
      );
      navigate("/payment-successful");
    } catch (error) {
      console.error("Error placing order:", error);
      navigate("/payment-unsuccessful");
    }
  };

  const placeGuestOrder = async () => {
    try {
      if (!termsChecked) {
        toast.error(
          "Please agree to the terms & conditions before placing the order."
        );
        return;
      }

      const paymentMethod = selectedPaymentMethod;
      let orderAmount = total;
      setTotal(orderAmount);
      setCouponApplied(true);
      let discountVal = parseFloat(discount).toFixed(1);
      let shipping = parseFloat(deliveryCharge).toFixed(1);

      const fullAddress = [houseName, street, city, state, country, pinCode]
        .filter(Boolean)
        .join(", ");

      console.log("guest", mobile, name);
      const response = await axios.post(
        `${BASE_URL}/api/guest-cart/place-order?guestId=${guestId}&name=${name}&mobile=${mobile}&finalOrderAmount=${orderAmount}&address=${fullAddress}&paymentMethod=${paymentMethod}`
      );
      navigate("/payment-successful");
    } catch (error) {
      console.error("Error placing order:", error);
      navigate("/payment-unsuccessful");
    }
  };

  const handleAddAddress = async (event) => {
    if (event) {
      event.preventDefault();
    }
    setAddressErrors((prevErrors) => ({ ...prevErrors, allFields: "" }));

    const sanitizedAddressName = address.houseName.replace(/\s+/g, "");
    const sanitizedCity = address.city.replace(/\s+/g, "");
    const sanitizedStreet = address.street.replace(/\s+/g, "");
    const sanitizedState = address.state.replace(/\s+/g, "");
    const sanitizedCountry = address.country.replace(/\s+/g, "");
    const sanitizedPinCode = address.pinCode.replace(/\s+/g, "");

    if (
      !sanitizedAddressName ||
      !sanitizedCity ||
      !sanitizedStreet ||
      !sanitizedState ||
      !sanitizedCountry ||
      !sanitizedPinCode
    ) {
      setAddressErrors({ allFields: "Please fill in all required fields." });
      toast.error("Please fill in all required fields!");
      return false;
    }

    if (!/^\d{6}$/.test(address.pinCode)) {
      setAddressErrors((prevErrors) => ({
        ...prevErrors,
        pinCode: "Please enter a valid 6-digit pin code.",
      }));
      toast.error("Please enter valid 6-digit code");
      return false;
    }

    try {
      const userId = localStorage.getItem("userId");
      const newAddrId = allAddresses.length + 1;

      const newAddressData = {
        ...address,
        addrId: newAddrId.toString(),
      };

      const addressRes = await axios.post(
        `${BASE_URL}/users/addNewAddress/${userId}`,
        newAddressData
      );

      if (addressRes && addressRes.data) {
        toast.success("Address added successfully!");
        await fetchAddresses();
        setSelectedAddress(newAddressData);
        return true;
      }
    } catch (error) {
      console.error("Error adding address:", error);
      toast.error("Error adding address. Please try again.");
      return false;
    }
  };

  const getCopounData = async () => {
    try {
      if (appliedCode === "") {
        return;
      }
      const response = await fetch(
        `${BASE_URL}/api/coupons/name/${appliedCode}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        return;
      }

      const couponData = await response.json();
      let discount = 0;

      if (couponData.couponType === "%") {
        discount = subtotal * (couponData.couponValue / 100);
      } else if (couponData.couponType === "Rs") {
        discount = couponData.couponValue;
      }
      setDiscount(discount);
      setTotal(subtotal - discount + deliveryCharge);
      setCouponApplied(true);
    } catch (error) {
      console.error("Error in API request:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Address submitted:", address);
    // Implement submit logic here
  };

  return (
    <div className="checkout-page">
      <Header />
      <h1>Checkout</h1>
      <Container fluid className="p-3">
        <Row className="mt-4 justify-content-center">
          <Col sm={12} md={8} lg={6} xl={7}>
            <Card
              className="mb-3"
              style={{
                background: "#f6f8e7",
                border: "none",
                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              }}
            >
              <Card.Body>
                <Card.Title
                  style={{ fontWeight: "bold", marginBottom: "30px" }}
                >
                  Delivery Address
                </Card.Title>
                <Form onSubmit={handleSubmit}>
                  <Form.Group
                    controlId="countryRegion"
                    className="custom-dropdown mb-3 mt-3"
                  >
                    <Form.Label>Country/Region</Form.Label>
                    <Form.Control
                      as="select"
                      name="country"
                      value={!userId ? country : address.country}
                      onChange={(e) => {
                        const updatedValue = e.target.value;

                        if (!userId) {
                          setCountry(updatedValue);
                        } else {
                          handleInputChange(e);
                        }
                      }}
                    >
                      <option value="India">India</option>
                    </Form.Control>
                  </Form.Group>
                  <Row>
                    <Col className="mb-3">
                      <Form.Group
                        controlId="firstName"
                        style={{ width: "100%" }}
                      >
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Full Name"
                          value={!userId ? name : personaldetails.name}
                          onChange={(e) => {
                            const updatedValue = e.target.value;

                            if (!userId) {
                              setName(updatedValue);
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          style={{ width: "100%", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mb-3">
                      <Form.Group controlId="houseName">
                        <Form.Control
                          type="text"
                          name="houseName"
                          placeholder="House Name"
                          value={!userId ? houseName : address.houseName}
                          onChange={(e) => {
                            const updatedValue = e.target.value;

                            if (!userId) {
                              setHouseName(updatedValue);
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          style={{ width: "100%", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="mb-3">
                      <Form.Group controlId="street">
                        <Form.Control
                          type="text"
                          name="street"
                          placeholder="Street"
                          value={!userId ? street : address.street}
                          onChange={(e) => {
                            const updatedValue = e.target.value;

                            if (!userId) {
                              setStreet(updatedValue);
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          style={{ width: "100%", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col className="mb-3">
                      <Form.Group controlId="city">
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="City"
                          value={!userId ? city : address.city}
                          onChange={(e) => {
                            const updatedValue = e.target.value;

                            if (!userId) {
                              setCity(updatedValue);
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          style={{ width: "100%", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="mb-3">
                      <Form.Group controlId="state">
                        <Form.Control
                          type="text"
                          name="state"
                          placeholder="State"
                          value={!userId ? state : address.state}
                          onChange={(e) => {
                            const updatedValue = e.target.value;

                            if (!userId) {
                              setState(updatedValue);
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          style={{ width: "100%", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="mb-3">
                      <Form.Group controlId="pinCode">
                        <Form.Control
                          type="text"
                          name="pinCode"
                          placeholder="PIN Code"
                          value={!userId ? pinCode : address.pinCode}
                          onChange={(e) => {
                            const updatedValue = e.target.value;

                            if (!userId) {
                              setPinCode(updatedValue);
                            } else {
                              handleInputChange(e);
                            }
                          }}
                          style={{ width: "100%", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group controlId="phoneNumber" className="mb-3">
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      placeholder="Phone Number"
                      value={!userId ? mobile : personaldetails.phoneNumber}
                      onChange={(e) => {
                        const updatedValue = e.target.value;

                        if (!userId) {
                          setMobile(updatedValue);
                        } else {
                          handleInputChange(e);
                        }
                      }}
                      style={{ width: "100%", height: "50px" }}
                    />
                  </Form.Group>
                </Form>
                <div className="saved-addresses">
                  {allAddresses.map((savedAddress) => (
                    <Card
                      key={savedAddress.addrId}
                      className="saved-address-card mb-3"
                    >
                      <Card.Body>
                        <Form.Check
                          type="radio"
                          className="custom-radio"
                          name="savedAddress"
                          id={`savedAddress${savedAddress.addrId}`}
                          label={
                            <>
                              <div>
                                {savedAddress.houseName}, {savedAddress.street}{" "}
                              </div>
                              <div>
                                {savedAddress.city}, {savedAddress.state} -{" "}
                                {savedAddress.pinCode}
                              </div>
                            </>
                          }
                          onChange={() => handleSelectAddress(savedAddress)}
                          checked={
                            selectedAddress &&
                            selectedAddress.addrId === savedAddress.addrId
                          }
                        />
                        <div>
                          <Button
                            variant="link"
                            className="edit-button"
                            style={{
                              color: "black",
                              padding: "5px",
                              fontSize: "15px",
                              display: "inline-block",
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#editaddressModal"
                            onClick={() => handleEditAddressClick(savedAddress)}
                          >
                            Edit
                          </Button>
                          <EditAddress address={selectedAddress} />
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
                {allAddresses.length < 3 && (
                  <div>
                    <Button
                      variant="link"
                      className="add-new-address-button"
                      style={{ color: "black", fontSize: "18px" }}
                      data-bs-toggle="modal"
                      data-bs-target="#addressModal"
                    >
                      <FaPlus className="me-2" /> Add a new address
                    </Button>
                    <NewAddress />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={8} lg={4}>
            <Card
              className="mb-3 order-Summery"
              style={{
                background: "#f6f8e7",
                border: "none",
                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              }}
            >
              <Card.Body>
                <Card.Title style={{ fontWeight: "bold" }}>
                  Order Summary
                </Card.Title>
                <ul className="list-group list-group-flush">
                  {cartItems.map((ele) => (
                    <li
                      key={ele.id}
                      className="list-group-item d-flex orderSummery justify-content-between align-items-center py-3"
                    >
                      <div
                        className="productImage-container"
                        data-quantity={ele.orderQuantity}
                      >
                        <img
                          className="productImage"
                          width="100%"
                          height="100px"
                          src={ele.productImage}
                          alt="item image"
                        />
                      </div>

                      {ele.productName}
                      <span>Rs {ele.productRate}</span>
                    </li>
                  ))}
                </ul>
                <hr />
                <div className="mt-3">
                  <div className="d-flex justify-content-between mb-2">
                    <div>Sub Total of ({cartItems.length}) Items</div>
                    <div>Rs {subtotal.toFixed(2)}</div>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <p
                      style={{
                        marginTop: "0px",
                        color: "#0b9931",
                        fontStyle: "italic",
                      }}
                    >
                      Shipping Charges as Applicable will be informed after
                      Order Confirmation.
                    </p>
                  </div>
                  {couponApplied && (
                    <div className="d-flex justify-content-between mb-2">
                      <div>Coupon Discount</div>
                      <div>Rs {discount}</div>
                    </div>
                  )}
                  <hr />
                  <div className="d-flex justify-content-between fw-bold mt-3">
                    <div>Total</div>
                    <div>Rs {total.toFixed(2)}</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
            <Form.Check
              type="checkbox"
              checked={termsChecked}
              onChange={() => setTermsChecked(!termsChecked)}
              label="I have read and agree to the terms & conditions"
              className="mt-4 custom-radio mb-3"
            />
            <Form.Check
              type="radio"
              name="paymentMethod"
              id="onlinePayment"
              value="onlinePayment"
              label="Online Payment"
              style={{ fontWeight: "bold" }}
              checked={selectedPaymentMethod === "onlinePayment"}
              onChange={handlePaymentMethodChange}
              className="mt-2 custom-radio"
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col sm={6} md={6} lg={3}>
            <Button
              onClick={!userId ? placeGuestOrder : placeOrder}
              className="w-100 mt-3 pt-3 pb-3 "
              style={{
                background: "#a7bb00",
                border: "none",
                fontSize: "20px",
                display: "block",
              }}
            >
              Place Order
            </Button>
          </Col>
        </Row>
      </Container>
      <Footer />

      {/* Callback Modal */}
    </div>
  );
};

export default CheckoutPage;
